import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=15074f06&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=15074f06&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15074f06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15074f06')) {
      api.createRecord('15074f06', component.options)
    } else {
      api.reload('15074f06', component.options)
    }
    module.hot.accept("./OrderDetail.vue?vue&type=template&id=15074f06&scoped=true", function () {
      api.rerender('15074f06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/tgOrderList/components/OrderDetail.vue"
export default component.exports